import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';
import { logErrorAndRunFail } from '../utils';

export interface GetLocalImgDataOption extends Partial<GeneralInvokeOption> {
  path: string;
}

// 获取本地base64图片
export function getLocalImgData(option: GetLocalImgDataOption) {
  if (!option?.path) {
    return logErrorAndRunFail(
      APINames.Native.GET_LOCAL_IMG_DATA,
      option,
      'parameter error:parameter.path should be String instead of Undefined.'
    );
  }
  return MacleJSBridge.beforeInvoke(APINames.Native.GET_LOCAL_IMG_DATA, option);
}
